import Repository from '@/repositories/marketing'
const resource = '/relational_queries'

export default {
    fetch(config){
        return Repository.get(`${resource}.json`,config)
    },
    delete(id){
        return Repository.delete(`${resource}/${id}.json`)
    },
    bulkDelete(config){
        return Repository.delete(`${resource}/bulk_delete.json`, config)
    },
    execute(id){
        return Repository.get(`${resource}/${id}/execute.json`)
    },
    export(id){
        return Repository.get(`${resource}/${id}/export.json`)
    },
    create(payload, config) {
        return Repository.post(`${resource}.json`,payload, config)
    },
    getIds (config) {
        return Repository.get(`/relational_tables.json`, config)
    },
    update(id, payload, config) {
        return Repository.put(`${resource}/${id}.json`, payload, config)
    },  
}